import { render, staticRenderFns } from "./HotZoneSettingWidget.vue?vue&type=template&id=bf963f4a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./HotZoneSettingWidget.vue?vue&type=script&lang=js&"
export * from "./HotZoneSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./HotZoneSettingWidget.vue?vue&type=style&index=0&id=bf963f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf963f4a",
  null
  
)

export default component.exports